export var cleanPortName = function (name) {
    var withoutPrefix = name.replace('in:', '').replace('out:', '');
    return withoutPrefix.replace(/__/g, '');
};
/**
 * Find the navigation type of the previous patch
 * else return an empty string
 * @param  {[]} edges array of edges
 * @param  {[]} patches array of patches
 * @param  {string} currentPatch id of the selected patch
 * @return {string || ''} string with the nav type or an empty string
 */
var findFromPatchNavigationType = function (edges, patches, currentPatch) {
    var _a;
    var findFromPatch = [];
    var findToPatchId = edges === null || edges === void 0 ? void 0 : edges.filter(function (edge) {
        return (edge === null || edge === void 0 ? void 0 : edge.to_patch) === currentPatch;
    });
    if ((findToPatchId === null || findToPatchId === void 0 ? void 0 : findToPatchId.length) === 1) {
        findFromPatch = patches === null || patches === void 0 ? void 0 : patches.filter(function (patch) {
            var _a;
            return (patch === null || patch === void 0 ? void 0 : patch.id) === ((_a = findToPatchId[0]) === null || _a === void 0 ? void 0 : _a.from_patch);
        });
    }
    if ((findFromPatch === null || findFromPatch === void 0 ? void 0 : findFromPatch.length) === 1) {
        return (_a = findFromPatch[0]) === null || _a === void 0 ? void 0 : _a.navigation;
    }
    else {
        return '';
    }
};
/**
 * return the options for the syntax builder in patch name
 * could be input or state else both
 * @param  {{}} patch selected patch object
 * @param  {[]} edges array of edges
 * @param  {[]} patches array of patches
 * @return {string[]} string with the nav type or an empty string
 */
export var getSyntaxBuilderOptions = function (patch, edges, patches) {
    if (patch.type === 'view') {
        if (patch.settings.connectedMenuType === 'menu' ||
            patch.settings.connectedMenuType === 'context' ||
            findFromPatchNavigationType(edges !== null && edges !== void 0 ? edges : [], patches !== null && patches !== void 0 ? patches : [], patch === null || patch === void 0 ? void 0 : patch.id) ===
                'submenu') {
            return ['state'];
        }
        else {
            return ['input', 'state'];
        }
    }
    else if (patch.type === 'list' || (patch === null || patch === void 0 ? void 0 : patch.type) === 'logic') {
        return ['state'];
    }
    else if (patch.type === 'navigation') {
        if (patch.navigation === 'drawer' || patch.navigation === 'submenu') {
            return ['state'];
        }
    }
    else {
        return ['input', 'state'];
    }
};
